var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body1"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"tit-p"},[_vm._v("INVEST IN A "),_c('br'),_vm._v("WORTHWHILE"),_c('br'),_vm._v("BUSINESS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e672e9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/franchise/e-body1.vue
// module id = 261
// module chunks = 0